import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { MarginType } from './margin';
import MarginComponent from '../../components/customComponents/MarginComponent';
import PaddingComponent from '../../components/customComponents/PaddingComponent';
import CustomizePanel from '../../components/order-summary/customize-props';
import { PaddingType } from './padding';
import Border from './Border';
import ColorPicker from './ColorPicker';
import OrderSummaryCart from './orderSummaryCart';
import { PostUpsellOrderSummaryContentPropsDefault } from '../../components/order-summary/postUpsellOrderSummary/PostUpsellOrderSummary';

interface PostUpsellOrderSummaryContentProps {
  value: PostUpsellOrderSummaryContentPropsDefault;
  onChange: (_value: PostUpsellOrderSummaryContentPropsDefault) => void;
  title: string;
  showComponent?: boolean;
  showHover?: boolean;
}

const PostUpsellOrderSummaryContent: React.FC<
  PostUpsellOrderSummaryContentProps
> = ({ value, onChange, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <ColorPicker
            value={value.backgroundColor}
            onChange={color => {
              onChange({
                ...value,
                backgroundColor: color,
              });
            }}
            label={'Background Color'}
            tooltip={'backgroundColor'}
          />
          <MarginComponent
            value={value.margin}
            onChange={(values: MarginType) => {
              onChange({ ...value, margin: values });
            }}
          />
          <PaddingComponent
            value={value.padding}
            onChange={(values: PaddingType) => {
              onChange({ ...value, padding: values });
            }}
          />
          <Border
            value={value?.border}
            onChange={val => {
              onChange({ ...value, border: val });
            }}
            title="Border"
          />
          <CustomizePanel
            title="Sales Tax"
            value={value.SalesTax}
            onChange={values => {
              onChange({ ...value, SalesTax: values });
            }}
          />
          <CustomizePanel
            title="Calculated Fees"
            value={value.CalculatedFees}
            onChange={values => {
              onChange({ ...value, CalculatedFees: values });
            }}
          />
          <CustomizePanel
            title="Grand Total"
            value={value.GrandTotal}
            onChange={values => {
              onChange({ ...value, GrandTotal: values });
            }}
          />
          <OrderSummaryCart
            title="Order Summary Cart"
            value={value.productDetails}
            onChange={values => {
              onChange({ ...value, productDetails: values });
            }}
          />
        </div>
      )}
    </div>
  );
};

export default PostUpsellOrderSummaryContent;
